export function interpolateMessage(template: string, ...values: any[]): string {
  return template.replace(/{(\d+)}/g, (match, index) => {
    const i = parseInt(index, 10);
    return values[i] !== undefined ? values[i].toString() : match;
  });
}

export const truncateName = (fullName: string, otherName: string): string => {
  const maxLength = 30;
  let combinedName = fullName || '--';
  if (otherName) {
    combinedName += ` (${otherName})`;
  }

  if (combinedName.length > maxLength) {
    return combinedName.slice(0, maxLength - 3) + '...';
  }
  return combinedName;
}

export const normalizePhoneNumberKeyword = (keyword: string): string => {
  // Check if the keyword is a phone number
  const isPhoneNumber = /^[\d\s()-]+$/.test(keyword);

  // Normalize the phone number by removing special characters (spaces, parentheses, hyphens)
  const normalizedKeyword = isPhoneNumber ? keyword.replace(/[\s()-]/g, '') : keyword;
    
  return normalizedKeyword;
}